import { createIcon } from './createIcon';

/**
 * A four-point sparkle — "make it yours".
 *
 * One glyph for both entrances to personalization: the sidebar's nav row and
 * the settings dialog's section. They arrived as two separate drawings on
 * different grids (20px for the sidebar, 16px for the settings nav); the
 * sidebar's own comment asked for "the same thing" in both places, which one
 * shared glyph delivers better than two redraws that can drift apart.
 *
 * No default tint, unlike the sidebar-only glyphs: the settings nav lights its
 * icon up with the active row's colour, so it has to inherit. The sidebar
 * passes `color` at its call site to mute it against the label.
 */
export const PersonalizationIcon = createIcon({
  name: 'PersonalizationIcon',
  viewBox: '0 0 16 16',
  size: 16,
  children: (
    <>
      <path
        d="M8 1.75c.5 2.9 1.85 4.25 4.75 4.75-2.9.5-4.25 1.85-4.75 4.75C7.5 8.35 6.15 7 3.25 6.5 6.15 6 7.5 4.65 8 1.75Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M12.4 10.4c.25 1.45.95 2.15 2.4 2.4-1.45.25-2.15.95-2.4 2.4-.25-1.45-.95-2.15-2.4-2.4 1.45-.25 2.15-.95 2.4-2.4Z"
        fill="currentColor"
      />
    </>
  ),
});

export default PersonalizationIcon;
